<template>
  <v-list-item
    @click="click($event)"
  >
    <v-list-item-avatar
      v-if="hasIcon"
      size="20"
    >
      <v-icon size="20">
        {{ getIcon }}
      </v-icon>
    </v-list-item-avatar>
    <v-list-item-content class="text2 secondary300">
      {{ text }}
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'ContextMenuItem',
  props: {
    icon: {
      type: [String, Boolean],
      default: '',
    },
    text: {
      type: [String],
      default: '',
    },
  },
  computed: {
    hasIcon() {
      return this.icon !== undefined || this.icon !== null;
    },
    getIcon() {
      const { icon } = this;

      if (typeof icon === 'string') {
        if (this.hasMdi(icon)) {
          return icon;
        }
        return `mdi-${icon}`;
      }
      return icon;
    },
  },
  methods: {
    click(ev) {
      this.$emit('click', ev);
    },
    hasMdi(icon) {
      return String(icon).includes('mdi');
    },
  },
};
</script>
